import React from 'react';
import PropTypes from 'prop-types';
import StandardKnob from './StandardKnob';
import Meter from './Meter';
import SongStore from '../stores/SongStore';
import ChannelSequenceList from './ChannelSequenceList';
import QueueSequenceAction from '../actions/QueueSequenceAction';

export default class Channel extends React.Component {
  static propTypes = {
    number: PropTypes.number.isRequired,
  };

  static contextTypes = {
    getStore: PropTypes.func.isRequired,
    executeAction: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      channel: context.getStore(SongStore).getChannelByNumber(props.number),
      level: 0
    };

    context.getStore(SongStore).on("CHANNEL-" + props.number + "-CHANGE", this.handleChange.bind(this));
  }

  handleChange() {
    this.setState({
      channel: this.context.getStore(SongStore).getChannelByNumber(this.props.number)
    });
  }

  handleChannelStop() {
    this.context.executeAction(QueueSequenceAction, {
      channel: this.props.number,
      sequence: -1
    });
  }

  render() {
    var name = this.state.channel.name || "Channel " + (this.props.number+1);
    return (
      <div className="Channel">
        <header>
          <p>{name}</p>
        </header>
        <main>
          <ChannelSequenceList
            sequences={this.state.channel.sequences}
            number={this.props.number}
            selected={typeof this.props.selectedSequence === "undefined" ? -1 : this.props.selectedSequence}/>
        </main>
        <footer>
          <div className="stop" onClick={this.handleChannelStop.bind(this)}>

            <i className="material-icons icon">stop</i><span className="text">Stop</span></div>
          <Meter low={175} high={200} max={255} number={this.props.number}/>
          <div className="controls">
            <StandardKnob param={this.state.channel.gain}/>
            <StandardKnob param={this.state.channel.pan}/>
          </div>
        </footer>
      </div>
    );
  }
}
